import { getImageFromAssetFolder } from "../utils/assets";

const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen w-full flex px-4 items-center justify-center bg-gray-50">
      <div className="w-full max-w-md p-8 bg-white rounded-2xl shadow-sm">
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center text-white font-semibold overflow-hidden">
            <img
              src={getImageFromAssetFolder("short_logo.png")}
              className="w-full h-full"
              alt="Logo"
            />
          </div>
        </div>

        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
